export default function (event) {
    if (Array.isArray(event)) {
        event.forEach(e => {
            window.dispatchEvent(new CustomEvent(e))
        })
        return;
    }
    window.dispatchEvent(new CustomEvent(event))
};